import '../scss/main.scss';

import './react/agenda';

import Slider from './components/Slider';
import IsDraggable from './components/IsDraggable';
import EagerlyMailSubscription from './components/EagerlyMailSubscription';
import VideoPlayer from './components/VideoPlayer';
import PopUp from './components/PopUp';
import Nav from './components/Nav';
import NavLinks from './components/NavLinks';
import HideOnScroll from './components/HideOnScroll';
import ButtonRegister from './components/ButtonRegister';
import NewAccordion from './components/NewAccordion';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import { Draggable } from 'gsap/all';
import Ovatic from './components/Ovatic/ovatic';

document.querySelectorAll('.js-nav').forEach((el) => {
  new Nav(el);
});

document.querySelectorAll('.js-nav-links').forEach((el) => {
	new NavLinks(el);
 });

document.querySelectorAll('.js-accordion').forEach((el) => {
  const breakpoint = window.matchMedia(el.dataset.breakpoint);
  let instance = null;

  if (breakpoint.matches) {
    instance = new NewAccordion(el);
    el.dataset.initialised = true;
  }

  breakpoint.addEventListener('change', (e) => {
    if (e.matches) {
      instance = new NewAccordion(el);
      el.dataset.initialised = true;
    } else {
      instance.unmount();
      el.dataset.initialised = false;
    }
  });
});

document.querySelectorAll('.js-pop-up').forEach((el) => {
  new PopUp(el);
});

document.querySelectorAll('.js-slider').forEach((el) => {
  new Slider(el);
});


// Swap the js is Draggable for the new one
document.querySelectorAll('.js-is-draggable').forEach((el) => {
  new IsDraggable(el);
});

// Newsletter Sign up
document.querySelectorAll('.js-newsletter').forEach((el) => new EagerlyMailSubscription(el));
document.querySelectorAll('.js-video-player').forEach((el) => {
  new VideoPlayer(el);
});

document.querySelectorAll('.js-hide-on-scroll').forEach((el) => {
  new HideOnScroll(el);
});

document.querySelectorAll('.js-button-register').forEach((el) => {
  new ButtonRegister(el);
});

if (/iP(hone|od|ad)/.test(navigator.userAgent)) {
	document.querySelectorAll('a').forEach(function (el) {
		el.addEventListener('touchend', function () {
			el.click();
		}, false);
	});
}
